import { HttpErrorResponse } from '@angular/common/http';
export function createErrorModel(_a) {
    var err = _a.err, section = _a.section, message = _a.message, requestEntity = _a.requestEntity;
    if (err instanceof HttpErrorResponse) {
        switch (err.status) {
            case 401: return { code: 'UNAUTHORISED', message: 'Unauthorised', section: section, httpStatus: err.status, url: err.url, apiError: err.error, requestEntity: requestEntity };
            case 400: return { code: 'BAD_REQUEST', message: 'Invalid Request', section: section, httpStatus: err.status, url: err.url, apiError: err.error, requestEntity: requestEntity };
            case 404: return { code: 'NOT_FOUND', message: 'Not found', section: section, httpStatus: err.status, url: err.url, apiError: err.error, requestEntity: requestEntity };
            case 422: return { code: getErrorCodeFromResponse(err), message: 'Unprocessable Entity', section: section, httpStatus: err.status, url: err.url, apiError: err.error, requestEntity: requestEntity };
            case 500: return { code: 'INTERNAL_ERROR', message: 'Internal Server Error', section: section, httpStatus: err.status, url: err.url, apiError: err.error, requestEntity: requestEntity };
            default: return { code: 'UNKNOWN_ERROR', message: 'Unknown Server Error', section: section, httpStatus: err.status, url: err.url, apiError: err.error, requestEntity: requestEntity };
        }
    }
    if (err != null && err.code != null) {
        return {
            code: err.code,
            message: message,
            section: section,
            httpStatus: null,
            url: null,
            apiError: err,
            requestEntity: requestEntity
        };
    }
    ;
    return {
        code: 'UNKNOWN_ERROR',
        message: message || 'Unknown Server Error',
        section: section,
        httpStatus: err != null ? err.status : null,
        url: err != null ? err.url : null,
        apiError: err,
        requestEntity: requestEntity
    };
}
function getErrorCodeFromResponse(errorResponse) {
    var messageCode = errorResponse.error && errorResponse.error.messageCodes && errorResponse.error.messageCodes.length > 0 && errorResponse.error.messageCodes[0];
    return messageCode ? messageCode : 'UNPROCESSABLE_ENTITY';
}
